import { TDashboardComponent } from "MyDashboards/components/ComponentRegistry/types";
import { Element } from "MyDashboards/state/editorTypes";
import React from "react";
import Editor from "./Editor";
import RenderText from "./RenderText";

/**
 * This component renders a placeholder box in place of the actual element, can be used as default renderer
 */
const RichText: TDashboardComponent = {
  editorMode: "text",
  Edit: Editor,
  Render: ({ el }: { el: Element }) => {
    const [slideNumber, tagname] = el.tag.split("#");
    if (!tagname) {
      // can not render text without
      return <div>no tag</div>;
    }
    return <RenderText el={el} slideNumber={Number(slideNumber)} />;
  },
};
export default RichText;
